import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "headerBox"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<a class=\"logo\" href=\"/\"><img src=\"" + _imports_0 + "\"></a><nav class=\"menuNav\"><a class=\"menuLink\" href=\"https://www.niftyrex.io/\">HOME</a><a class=\"menuLink\" href=\"/maze\">MAZE</a><a class=\"menuLink\" href=\"https://www.niftyrex.io/collection\">COLLECTION</a></nav><div class=\"elgd-community-container\"><iframe title=\"elgd-community\" src=\"https://egld.community/api/products/a32897ca-6afe-4da7-ba3b-6e462d1fb3a5/upvotes/embed\"></iframe></div>", 3)
const _hoisted_5 = {
  key: 1,
  class: "phoneMenu__phone menuStake"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "checkMenu",
  class: "phoneMenu__phone-check"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "phoneMenu__phone-span" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "phoneMenu__phone-span" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "phoneMenu__phone-span" }, null, -1)
const _hoisted_10 = { class: "phoneMenu__links" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "logo",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bigLogo",
    src: _imports_0
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("nav", { class: "menuNav" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "menuLink",
    href: "https://www.niftyrex.io/"
  }, "HOME"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "menuLink",
    href: "/maze"
  }, "MAZE"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "menuLink",
    href: "https://www.niftyrex.io/collection"
  }, "COLLECTION")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!

  return ($data.isDesktop)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Login)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Login),
          _hoisted_12
        ])
      ]))
}